import { create } from 'zustand';
import type { ClassificationResult, ContactSource } from '../types';

interface PendingTask {
  taskId: string;
  classification: ClassificationResult;
  plan: {
    contactName: string | null;
    contactPhone: string | null;
    contactSource: ContactSource | null;
    inferredContext: string | null;
    talkingPoints: string | null;
    emailSubject: string | null;
    emailBody: string | null;
  };
  requiresContact: boolean;
  requiresPhoneAuth: boolean;
  requiresEmailAuth: boolean;
  message?: string;
}

interface TaskState {
  pendingTask: PendingTask | null;
  setPendingTask: (task: PendingTask | null) => void;
  clearPendingTask: () => void;
}

export const useTaskStore = create<TaskState>((set) => ({
  pendingTask: null,
  setPendingTask: (pendingTask) => set({ pendingTask }),
  clearPendingTask: () => set({ pendingTask: null }),
}));
